import { CheckoutFlow } from "../types";

export interface IEndpointsPreset {
  subscriptions: string;
  summary: string;
  preview: string;
  purchase: string;
  existingPaymentMethod: string;
  details: string;
}

// TODO in SL-5387: utilise isV2 and add those new endpoints
export const getDefaultEndpointsPreset = (url: string) => ({
  subscriptions: `${url}plans/renewal`,
  summary: `${url}account`,
  preview: `${url}checkout/preview`,
  purchase: `${url}checkout/purchase`,
  existingPaymentMethod: `${url}account/activepaymentmethod`,
  details: `${url}account/details`,
});

export const getJoiningEndpointsPreset = (url: string) => ({
  subscriptions: `${url}plans/joining`,
  summary: `${url}account/summary`,
  preview: `${url}joining/preview`,
  purchase: `${url}account/billing`,
  existingPaymentMethod: "",
  details: "",
});

export const getSubscriptionEndpointsPreset = (url: string) => ({
  subscriptions: `${url}plans/upgrade`,
  summary: `${url}account`,
  preview: `${url}subscription/preview`,
  purchase: `${url}account/billing-info`,
  existingPaymentMethod: `${url}account/activepaymentmethod`,
  details: "",
});

export const getGraduateTransferEndpointsPreset = (url: string) => ({
  subscriptions: `${url}plans/transfer`,
  summary: `${url}account`,
  preview: `${url}checkout/preview`,
  purchase: "",
  existingPaymentMethod: `${url}account/activepaymentmethod`,
  details: "",
});

export const getChangePlanEndpointsPreset = (url: string) => ({
  subscriptions: `${url}plans/renewal`,
  summary: `${url}account`,
  preview: `${url}checkout/preview`,
  purchase: "",
  existingPaymentMethod: `${url}account/activepaymentmethod`,
  details: "",
});

export const endpointsPresets = {
  [CheckoutFlow.Default]: getDefaultEndpointsPreset,
  [CheckoutFlow.Joining]: getJoiningEndpointsPreset,
  [CheckoutFlow.AccountSettings]: getSubscriptionEndpointsPreset,
  [CheckoutFlow.SubscriptionsModals]: getDefaultEndpointsPreset,
  [CheckoutFlow.GraduateTransfer]: getGraduateTransferEndpointsPreset,
  [CheckoutFlow.ChangePlan]: getChangePlanEndpointsPreset,
};
